/**
 * 내 메시지(messageSeq) 기준, 나를 제외한 멤버 중 아직 해당 seq까지 읽지 않은 사람 수.
 * lastReadSeq >= messageSeq 이면 그 메시지까지 읽은 것으로 봄.
 */
export function countMembersNotReadMessage(messageSeq, members, myUserId) {
  if (typeof messageSeq !== "number" || messageSeq <= 0 || !Array.isArray(members)) return 0;
  let c = 0;
  for (const m of members) {
    if (!m?.userId || m.userId === myUserId) continue;
    const read = typeof m.lastReadSeq === "number" ? m.lastReadSeq : 0;
    if (read < messageSeq) c += 1;
  }
  return c;
}
